import styled from 'styled-components'

import { colors, fontSizes } from '@/styles'

const ButtonElem = styled.button`
  outline: none;
  background: none;
  border: none;
  color: ${colors.secondary};
  font-size: ${fontSizes.regular};
  padding: 0;

  &:not(:disabled):not([disabled]) {
    cursor: pointer;
  }

  &:disabled,
  &[disabled] {
    background-color: #fc8985;
  }
`

const Button = ({ className, onClick, disabled, children, id }) => (
  <ButtonElem
    className={className}
    onClick={e => {
      e.preventDefault()
      onClick()
    }}
    role="button"
    disabled={disabled}
    id={id}
  >
    {children}
  </ButtonElem>
)

Button.defaultProps = {
  children: 'Button',
  className: '',
  disabled: false
}

export default Button
